<button class="secondarybutton {{ additionalClass }}" [ngClass]="dynamicClass" mat-button type="button" [attr.style]="styles" [disabled]="!!disabled" [attr.cdkFocusRegionStart]="focusRegionStart ? '' : null" (click)="trackButton()">
  @if (matIcon) {
    <mat-icon>{{ matIcon }}</mat-icon>
  }
  <ng-content></ng-content>
</button>
